// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"9b700d8f","839":"c4cbd960"}[chunkId] + ".chunk.js";
};